import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "control has-icons-left" }
const _hoisted_2 = { class: "select" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "icon is-left select-icon" }

import { DatePicker } from '@/features/reports/services';
import { SET_REPORTING_DATE_RANGE } from '@/store/reports/mutationTypes';
import { DateOption } from '@/features/reports/models';
import CalendarIcon from 'vue-material-design-icons/CalendarRange.vue';
import { useStore } from 'vuex';
import { computed, onMounted, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UsageDateRangeFilter',
  setup(__props) {

const store = useStore();
const selectedDateOption = computed(() => store.getters.selectedDateOption);
const isReportLoading = computed(() => store.getters.isReportLoading);
const setReportingDateRange = (dateOption: DateOption) => store.commit(SET_REPORTING_DATE_RANGE, dateOption);

const value = ref(DatePicker.monthOptions.thisMonth);

onMounted(() => (value.value = findMatchingValue(selectedDateOption.value) ?? DatePicker.options.thisMonth));
watch(value, (newValue) => setReportingDateRange(newValue));

function findMatchingValue(value: DateOption): DateOption | undefined {
  return dateOptions.value.find(
    (option) =>
      option.getDateRange().start.getTime() === value.getDateRange().start.getTime() &&
      option.getDateRange().end.getTime() === value.getDateRange().end.getTime(),
  );
}

const dateOptions = ref<DateOption[]>(
  DatePicker.monthOptions
    .toArray()
    .filter((m) => m.getDateRange().end.getFullYear() > 2021)
    .sort((a, b) => {
      const aIsNumeric = !isNaN(parseInt(a.label, 10));
      const bIsNumeric = !isNaN(parseInt(b.label, 10));
      if (aIsNumeric && bIsNumeric) {
        return parseInt(b.label, 10) - parseInt(a.label, 10);
      }
      if (aIsNumeric || bIsNumeric) {
        return -1;
      }
      return 0;
    }),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        disabled: isReportLoading.value
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateOptions.value, (range) => {
          return (_openBlock(), _createElementBlock("option", {
            key: range.label,
            value: range
          }, _toDisplayString(range.label), 9, _hoisted_4))
        }), 128))
      ], 8, _hoisted_3), [
        [_vModelSelect, value.value]
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(CalendarIcon, { class: "icon-1-3x dropdown-icons icon-adjustment flow-icon-adjustment" })
      ])
    ])
  ]))
}
}

})